<div class="d-flex flex-column">
	@for (file of version.files; track file.manifestationUri) {
		<div class="file-entry border-bottom border-dark pb-2 mb-2">
			<div class="mb-2">
				<it-icon
					[name]="getIconForContentType(file.contentType)"
				></it-icon>
				@if (showChangeActions) {
					@if (file.checkOutIdRole) {
						<button
							type="button"
							itButton="link"
							class="btn-icon"
							[disabled]="
								progressDeleteFileUri === file.manifestationUri
							"
							size="xs"
							(click)="unlockFileModal.toggle()"
						>
							<it-icon
								name="locked"
								[title]="'iterlex.unlock-file' | translate"
							></it-icon>
						</button>
					} @else {
						<button
							type="button"
							itButton="link"
							class="btn-icon"
							[disabled]="
								progressDeleteFileUri === file.manifestationUri
							"
							size="xs"
							(click)="lockFileModal.toggle()"
						>
							<it-icon
								name="unlocked"
								[title]="'iterlex.lock-file' | translate"
							></it-icon>
						</button>
					}
				}
				<span>{{ file.title }}</span>
			</div>
			@if (isFileSupportedByReadylex(file)) {
				<a
					[href]="openInReadylexLink(file)"
					itButton="secondary"
					[disabled]="progressDeleteFileUri === file.manifestationUri"
					size="xs"
					target="_blank"
					class="me-3"
					>{{ "iterlex.open-in-readylex" | translate }}</a
				>
			}
			<button
				type="button"
				itButton="outline-dark"
				[disabled]="progressDeleteFileUri === file.manifestationUri"
				(click)="documentLink(file)"
				size="xs"
				target="_blank"
				class="me-3"
			>
				<it-icon
					name="download"
					[title]="'it.general.download' | translate"
				></it-icon>
			</button>
			@if (showChangeActions) {
				<button
					type="button"
					class="btn-icon"
					itButton="outline-danger"
					[disabled]="progressDeleteFileUri === file.manifestationUri"
					[progress]="progressDeleteFileUri === file.manifestationUri"
					size="xs"
					(click)="deleteFileModal.toggle()"
				>
					<it-icon
						name="delete"
						color="danger"
						[title]="
							'it.form.delete-file'
								| translate: { name: file.title }
						"
					></it-icon>
				</button>
			}
			<it-modal #lockFileModal>
				<ng-container modalTitle>{{
					"iterlex.lock-file-confirm" | translate
				}}</ng-container>
				<form
					#lockFileForm="ngForm"
					(ngSubmit)="lockFile(lockFileForm, file.manifestationUri)"
				>
					@if (profileRoles.length > 1) {
						<it-select
							name="role"
							[label]="'iterlex.role' | translate"
							[ngModel]="getDefaultRole()"
							required
						>
							<option selected value="">
								{{ "iterlex.select-role" | translate }}
							</option>
							@for (role of profileRoles; track role.id) {
								<option [value]="role.id">
									{{
										role.label[
											"iterlex.currentLanguage"
												| translate
										]
									}}
								</option>
							}
						</it-select>
					}
					<button
						itButton="primary"
						type="submit"
						[disabled]="!lockFileForm.valid"
						data-bs-dismiss="modal"
					>
						{{ "iterlex.lock-file" | translate }}
					</button>
				</form>
				<ng-container footer><span></span></ng-container>
			</it-modal>
			<it-modal #unlockFileModal>
				<ng-container modalTitle>{{
					"iterlex.unlock-file-confirm" | translate
				}}</ng-container>
				<form
					#unlockFileForm="ngForm"
					(ngSubmit)="
						unlockFile(
							unlockFileForm,
							file.manifestationUri,
							file.checkOutIdRole
						)
					"
				>
					<div class="form-group">
						<input
							type="file"
							name="file"
							ngModel
							(change)="setCurrentFile($event.target.files)"
						/>
					</div>
					<button
						itButton="primary"
						type="submit"
						[disabled]="!unlockFileForm.valid"
						data-bs-dismiss="modal"
					>
						{{ "iterlex.unlock-file" | translate }}
					</button>
				</form>
				<ng-container footer><span></span></ng-container>
			</it-modal>
			<it-modal #deleteFileModal closeButton="false" popconfirm="true">
				<ng-container modalTitle>{{
					"iterlex.delete-file-confirm" | translate
				}}</ng-container>
				<p>
					{{
						"iterlex.delete-file-confirm-description"
							| translate: { name: file.title }
					}}
				</p>
				<ng-container footer>
					<button
						itButton="danger"
						type="button"
						data-bs-dismiss="modal"
						(click)="deleteFile(file.manifestationUri)"
					>
						{{ "it.core.remove" | translate }}
					</button>
					<button
						itButton="outline-secondary"
						type="button"
						data-bs-dismiss="modal"
					>
						{{ "iterlex.cancel" | translate }}
					</button>
				</ng-container>
			</it-modal>
		</div>
	}
</div>
@if (showChangeActions) {
	<div>
		<it-upload-file-list
			[fileList]="uploadedFileList"
			(deleteItem)="onDeleteFileList($event)"
			(uploadFiles)="onUpdateFileList($event, version)"
		></it-upload-file-list>
	</div>
}
